import { cn } from 'cpool-components/utils';
import type {
    SchemaTemplateResolver_GetMailTemplates,
    SchemaTemplateResolver_GetOfferTemplates,
} from 'cpool-tables/backend-resolvers';

type Props = {
    hoverClassName?: string;
    isActive: boolean;
    onClick: () => void;
    template: SchemaTemplateResolver_GetMailTemplates[number] | SchemaTemplateResolver_GetOfferTemplates[number];
};

export const TemplateEntryButton: React.FC<Props> = ({ hoverClassName, isActive, onClick, template }) => {
    return (
        <button
            type="button"
            className={cn(
                'flex h-[38px] w-full items-center px-[14px] py-1 text-left text-sm text-midnight transition-colors',
                isActive ? 'bg-midnight text-white' : cn('bg-white hover:bg-surface-light', hoverClassName),
            )}
            onClick={onClick}
            aria-current={isActive ? 'true' : undefined}
        >
            <span className="truncate">{template.name}</span>
        </button>
    );
};
